import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Instagram from '../../components/Cards/instagram';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import fiferries from '../../assets/img/instagram/profiles/fiferries.jpg';
import instagram from './images/replaceME.jpg';

export default () => (
  <div>
    <Helmet
      title='Fire Island Ferries | Seaview'
      meta={[
        {
          name: 'description',
          content:
            'Seaview is a family friendly community offering wholesome fun for everyone.',
        },
        {
          name: 'keywords',
          content:
            'Seaview, Fire Island, New York, Long Island, Ferries, Water Taxi',
        },
      ]}
    />
    <Navigation />
    <div className='container p-0'>
      <PageHeader beach='Seaview'>
        <h2>Communities</h2>
        <h1>Seaview</h1>
        <p>Amenities</p>
        <div className='amenities'>
          {Amenities.byBeach('Seaview').map((item) => (
            <i
              key={item.text}
              className={`icon-${item.icon}`}
              title={item.text}
            />
          ))}
        </div>
        <div>
          <Link className='btn btn-outline-light' to='/schedules/seaview'>
            Schedules
          </Link>
          &nbsp;&nbsp;
          <Link className='btn btn-outline-light' to='/directory'>
            Directory
          </Link>
        </div>
      </PageHeader>
    </div>
    <div className='container page'>
      <div className='row'>
        <div className='col-xl'>
          <div className='heading'>
            <h1>About Seaview</h1>
          </div>
          <p>
            Seaview is the small community nestled between the Village of Ocean
            Beach and Ocean Bay Park. This town has a wonderful market and
            liquor store located directly next to the ferry basin. This
            family-friendly community has wholesome fun for the whole family
            thanks to its playground, wading pool, tennis & basketball courts,
            and baseball field. Seaview uses Fire Island Synagogue as a place of
            worship and a community meeting place. Its recently remodeled walks
            bring a bit of old world charm to Fire Island.
          </p>
        </div>
        {/* <div className="col-xl-4">
          <Instagram account="fiferries" datestamp="June 23, 2016" profile={fiferries} image={instagram} link="https://www.instagram.com/fiferries" className="mx-auto" />
        </div> */}
      </div>
      <Tip title="Captain's Tip">
        When returning on the ferry be sure to hand your blue valet ticket to a
        deckhand so your car will be waiting for you when you disembark.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Seaview is available by Fire Island Ferries
        from Bay Shore.{' '}
        <Link to='/schedules/seaview'>Click here for schedules.</Link>
      </p>
      <p>
        <a href='http://www.fireislandwatertaxi.com'>Water Taxi</a> service is
        available to and from Seaview during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
